export const updateOccupation = (occupationInfo) => ({
  type: "UPDATE_OCCUPATION", 
  payload: {
    ...occupationInfo
  }
});


// WEBPACK FOOTER //
// ./src/actions/occupationAction.js